/// <reference path="../../auth_form_default/js/gmr.d.ts" />
/// <reference path="IFormOptions.d.ts" />
/// <reference path="../../auth_form_default/js/IFormState.d.ts" />
import DefaultForm from '../../auth_form_default/js/DefaultForm';
import CookieController from '../../../js/lib/CookieController';

export default class AuthMailForm extends DefaultForm {
    form_id = 'mailAuthForm';
    gmr : GMR;
    options : IFormOptions;
    css_uri = 'https://sf.cdn.gmru.net/static/sf.mail.ru/blocks/auth_mail_form/css/main.css';
    constructor () {
        super();
        this.options = {};
        this.state = {
            rendered : false,
            visible : false
        };
    }


    public init (options : IFormOptions) {
        this.parseOptions(options);
        if (this.options.load_css) {
            this.loadCss(this.css_uri);
        }
        this.renderForm();
    }

    private parseOptions (options : IFormOptions) {
        if (!options.gmr) {
            throw new Error('GMR is not defined');
        }
        this.gmr = options.gmr;
        this.options = options;
    }


    private renderForm () {
        var html = this.getHtmlTemplate();
        $('body').append(html);
        this.$form = $('#' + this.form_id);
        this.state.rendered = true;
        this.initEvents();
        if (this.options.visible) {
            this.showForm();
        } else {
            this.hideForm();
        }
        if (this.options.auto_show_once) {
            if (!this.isFormAlreadyShowed()) {
                this.showForm();
                this.setShowOnceCookie();
            }
        }
    }


    private isFormAlreadyShowed () {
        return CookieController.readCookie('sf_show_reg_form');
    }
    private setShowOnceCookie () {
        var d = new Date();
        d.setTime(d.getTime() + 24*60*60*1000);
        CookieController.setCookie('sf_show_reg_form', d.getTime() , {expires : d});
    }

    private setConfirmRegCookie () {
        var unixtime = Math.floor(Date.now() / 1000) + 86400;
        document.cookie = "confirm_reg=" + unixtime + "; path=/;";
        if (this.options.gift) {
            document.cookie = "sf_gift=" + unixtime + "; path=/;";
        }
        if (this.options.wm_gift) {
            document.cookie = "sf_wm_gift=" + unixtime + "; path=/;";
        }
        if (this.options.roulette_gift) {
            document.cookie = "lp_roulette=" + unixtime + "; path=/;";
        }
        if (this.options.gift_41) {
            document.cookie = "sf_gift_41=" + unixtime + "; path=/;";
        }
        return true;
    }

    private redirect (url) {
        location.href = url;
    }

    private initEvents () {
        var that = this;
        if (!this.$form) {
            throw new Error('Form is not rendered');
        }

        $('.js-change-email', this.$form).on('click', function () {
            that.gmr.showSigninForm();
        });
        $('.js-button--confirm-reg', this.$form).on('click', function () {

            that.forceReg();
        });

        $('.js-button--vk ', this.$form).on('click', function () {
            that.gmr.showVKSigninForm();
            return false;
        });

        $('.js-button--ok', this.$form).on('click', function () {
            that.gmr.showOKSigninForm();
            return false;
        });

        $('.js-button--close', this.$form).on('click', function () {
            that.hideForm();
            return false;
        });

    }

    private getHtmlTemplate () {
        var id = this.form_id, email = this.options.email;
        var html = `
        <div class="popup_wrapper"  id="${id}">
            <div class="user-mailru-auth-form" >
                <div class="user-mailru-auth-form__logo"></div>
                <h3 class="user-mailru-auth-form__header">Регистрация</h3>
                <div class="user-mailru-auth-form__close-button js-button--close"></div>
                <div class="user-mailru-auth-form__column">
                    <div class="user-mailru-auth-form__column-title"><span>C помощью вашей почты</span></div>
                    <div class="user-mailru-auth-form__mail js-email">${email}</div>
                    <div class="user-mailru-auth-form__column-bottom js-change-email"><a>сменить почту</a></div>
                </div>
                <div class="user-mailru-auth-form__button-reg news_custom_link js-button--confirm-reg" >Зарегистрироваться</div>

                <div class="user-mailru-auth-form__column  user-auth-form__column--2">
                    <div class="user-mailru-auth-form__column-title"><span>Через социальные сети</span></div>
                    <div class="user-mailru-auth-form__button user-mailru-auth-form__button--vk js-button--vk">Войти через ВКонтакте</div>
                    <div class="user-mailru-auth-form__button user-mailru-auth-form__button--ok js-button--ok">Войти через Одноклассники</div>
                </div>
                <p class="user-mailru-auth-form__rules-text">Регистрируясь, я принимаю условия
                     <a href="https://sf.mail.ru/static/sf.mail.ru/license_agreement.html" target="_blank">Лицензионного соглашения</a>,<br/>
                <a href="https://sf.mail.ru/static/sf.mail.ru/game_rules.html" target="_blank">Правил игры</a>,
                 <a href="https://sf.mail.ru/static/sf.mail.ru/forum_rules.html" target="_blank">Правил Форума</a> и
                  <a href="https://help.mail.ru/legal/games/privacy/sf" target="_blank">Политики конфиденциальности</a>.</p>
            </div>
        </div>`;
        return html.replace(/\s\s*$/gm, "");
    }

    public forceReg () {
        if (this.options.confirm_reg_url) {
            this.setConfirmRegCookie();
            this.redirect(this.options.confirm_reg_url);
        }
    }

    public setMail (email : string) {
        this.options.email = email;
        if (this.state.rendered) {
            $('.user-mailru-auth-form__mail', this.$form).text(email);
        }
    }
}
